import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PaginationAdvanced from "../PaginationAdvanced";
import { CSSTransitionGroup } from 'react-transition-group';
import moment from "moment";
import Search from "../Search";
import { toastr } from "react-redux-toastr";
import * as Constants from '../../constants';

import Index from "../Index";
import { fetchLeads } from "../../actions/index";

export class AdminLeadsIndex extends Index {
  static propTypes = {
    fetchLeads: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    leads: PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  fetchData() {
    let newQueries = {
        page: this.state.page || 1,
        per_page: this.state.per_page || "",
        search: this.state.search || "",
        category: this.state.category || "",
        sort: this.state.sort || "",
        direction: this.state.direction || ""
      };
    this.props.fetchLeads(
      this.serialize(newQueries)
    );
    this.props.history.push(`/admin/leads${this.serialize(newQueries)}`);
  }

  renderLeads() {
    let query = new URLSearchParams(this.props.location.search);
    if (!this.props.leads.data) {
      return (
        <tr>
          <td colSpan={15}>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              />
            </div>
          </td>
        </tr>
      );
    } else if (query.get('search').length == 0) {
      return (
        <tr>
          <td colSpan={15}>
            <div className="well well-lg text-center">
              Enter a leads email, unique identifier, or pourover id to search.&nbsp;
            </div>
          </td>
        </tr>
      );
    } else if (this.props.leads.data.length == 0) {
      return (
        <tr>
          <td colSpan={15}>
            <div className="well well-lg text-center">
              No Leads found.&nbsp;
            </div>
          </td>
        </tr>
      );
    }

    return this.props.leads.data.map(lead => {
      return (
        <tr key={lead.id}>
          <td>{lead.id}</td>
          <td>{lead.external_id}</td>
          <td>{lead.first_name}</td>
          <td>{lead.last_name}</td>
          <td>{lead.email}</td>
          <td>{lead.company_site_uuid}</td>
          <td>{lead.company_name}</td>
          <td className="text-left">
            <Link
              to={`/admin/leads/${
                lead.id
              }/filter_logs?${Constants.DEFAULT_PAGINATION}`}
              className="btn btn-xs btn-default lead_filter_logs"
            >
              Filter Logs
            </Link>
          </td>
        </tr>
      );
    });
  }

  render() {
    let count = 0;
    if (this.props.leads.meta) {
      count = this.props.leads.meta.count;
    }
    return (
      <div className="leads_index">
        <div className="row">
          <h1>
            Leads
            <div className="pull-right">
              <Search
                handleSearch={this.handleSearch.bind(this)}
                searchStr={this.state.search}
              />
            </div>
          </h1>
        </div>
        <div className="row">
          <table className="table table-striped">
            <thead>
              <tr>
                <th
                  className={`lead_id ${this.indicateSorting(
                    "id"
                  )}`}
                  data-sort="id"
                  onClick={this.handleOrder.bind(this)}
                >
                  ID
                </th>
                <th
                  className={`lead_external_id ${this.indicateSorting(
                    "external_id"
                  )}`}
                  data-sort="external_id"
                  onClick={this.handleOrder.bind(this)}
                >
                  LM ID
                </th>
                <th
                  className={`lead_first_name ${this.indicateSorting(
                    "first-name"
                  )}`}
                  data-sort="name"
                  onClick={this.handleOrder.bind(this)}
                >
                  First
                </th>
                <th
                  className={`lead_first_name ${this.indicateSorting(
                    "last_name"
                  )}`}
                  data-sort="name"
                  onClick={this.handleOrder.bind(this)}
                >
                  Last
                </th>
                <th
                  className={`lead_email ${this.indicateSorting(
                    "email"
                  )}`}
                  data-sort="email"
                  onClick={this.handleOrder.bind(this)}
                >
                  Email
                </th>
                <th >
                  Company Site UUID
                </th>
                <th >
                  Company Name
                </th>
                <th className="text-right" colSpan={2} />
              </tr>
            </thead>
            <tbody>{this.renderLeads()}</tbody>
          </table>
        </div>
        <div className="row text-right">
          <PaginationAdvanced
            handle={this.handlePagination.bind(this)}
            total={count}
            page={this.state.page}
            per_page={this.state.per_page}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { leads: state.leads.all };
}

export default connect(
  mapStateToProps,
  { fetchLeads }
)(AdminLeadsIndex);
